export const possibleEmails = [
  'lukasz.piotrowski329@gmail.com',
  'julchwalewski@gmail.com',
  'gustaw.daniel@gmail.com',
  'analizaumowy@gmail.com'
];
